import React from "react"

import { Helmet } from "react-helmet"
import { SearchState } from "react-instantsearch-core"
import { IntlShape } from "react-intl"

import { FormattedBanner } from "../../components/Banner/utils"
import FilteredRecipes from "../../components/FilteredRecipes/FilteredRecipes"
import { TemplateDefaultPropTypes } from "../withTemplate"
import { ResultState } from "./types"
import { AllCategories } from "~/hooks/useCategories"
import { RecipeAlgoliaHit } from "~/models/Recipe"
import { PageContextCategory } from "~/templates/Category/Category"

import css from "./FilterPage.module.scss"

interface PropTypes extends TemplateDefaultPropTypes {
  pageContext: TemplateDefaultPropTypes["pageContext"] & PageContextCategory
  createURL: (
    state: SearchState,
    CATEGORIES: AllCategories,
    baseSlug: string
  ) => string
  baseSlug: string
  urlToSearchState: (
    search: string,
    pathname: string,
    hash: string,
    CATEGORIES: AllCategories
  ) => SearchState
  searchStateToUrl: (
    searchState: SearchState,
    CATEGORIES: AllCategories,
    intl: IntlShape
  ) => any
  refreshTitle: (
    searchState: SearchState,
    CATEGORIES: AllCategories,
    isSSG: boolean,
    nbHits: number
  ) => {
    pageTitle: string
    pageH1?: string
    description?: string
    descriptionSEO?: string
  }
  bannerToDisplay: FormattedBanner | null
}

function FilterPage({
  pageContext,
  createURL,
  baseSlug,
  urlToSearchState,
  searchStateToUrl,
  refreshTitle,
  location,
  bannerToDisplay,
}: PropTypes) {
  const isSSGPage = !!pageContext.hits

  const resultState: ResultState<RecipeAlgoliaHit> = {
    hits: pageContext.hits,
    nbHits: pageContext.nbHits,
  }

  let hierarchicalFacets: any
  try {
    hierarchicalFacets = JSON.parse(pageContext.hierarchicalFacets)
  } catch (e) {
    //ignore
  }
  let verticalRefinementList: any
  try {
    verticalRefinementList = JSON.parse(pageContext.verticalRefinementList)
  } catch (e) {
    //ignore
  }
  let starIngredientsRefinementList: any
  try {
    starIngredientsRefinementList = JSON.parse(
      pageContext.starIngredientsRefinementList
    )
  } catch (e) {
    //ignore
  }

  return (
    <div className={css.Category}>
      {!isSSGPage && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      <FilteredRecipes
        baseSearchState={
          pageContext.searchState ? JSON.parse(pageContext.searchState) : {}
        }
        baseResultState={resultState}
        baseHierarchicalFacetsItems={hierarchicalFacets}
        baseVerticalRefinementListItems={verticalRefinementList}
        baseStarIngredientsRefinementListItems={starIngredientsRefinementList}
        baseSlug={baseSlug}
        createURL={createURL}
        urlToSearchState={urlToSearchState}
        searchStateToUrl={searchStateToUrl}
        refreshTitle={refreshTitle}
        pathname={pageContext.slug ?? location.pathname}
        location={location}
        bannerToDisplay={bannerToDisplay}
      />
    </div>
  )
}
export default FilterPage
